import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import { Provider, useSelector } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from "react-toastify";

import LoginPage from "./pages/LoginPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import DashboardLayout from "./components/DashboardLayout";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";

const AuthChecker = () => {
  // const user = useSelector((state) => state.auth.user);
  // let isAuth = false;
  // if (user) {
  //   const token = sessionStorage.getItem("token");
  //   if (token) {
  //     isAuth = true;
  //   }
  // }
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" /> : <LoginPage />}
      />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/auth/:token" element={<ChangePasswordPage />} />
      <Route
        path="/*"
        element={
          isAuthenticated ? <DashboardLayout /> : <Navigate to="/login" />
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AuthChecker />
      </Router>
      <ToastContainer
        position="top-right" // Vị trí mặc định cho tất cả toast
        autoClose={10000} // Tự động đóng sau ? mili giây
        hideProgressBar={false} // Không hiển thị thanh tiến trình
        newestOnTop={false} // Toast mới nhất nằm dưới
        closeOnClick // Đóng khi click
        rtl={false} // right-to-left text
        theme="light" // Chủ đề mặc định
      />
    </Provider>
  );
}

export default App;
